import * as React from 'react';
import { rem } from 'polished';
import { __r } from 'react-i18n';
import { PortalTooltip } from './PortalTooltip';
import styled from 'styled-components';

interface Props {
  infoLink?: string;
  infoDescription?: string;
  onInfoClick?: (e: any) => void;
}

export function InfoIcon({ infoLink, infoDescription, onInfoClick }: Props) {
  const iconRef = React.useRef<HTMLAnchorElement>(null);
  const [hovered, setHovered] = React.useState(false);

  return infoLink || infoDescription ? (
    <>
      <ValueInfoIconLink
        ref={iconRef as React.Ref<any>}
        href={infoLink ? __r(infoLink, infoLink) : undefined}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onInfoClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <ValueInfoIcon src="/images/icons/outline-info.svg" />
      </ValueInfoIconLink>

      {hovered && infoDescription && (
        <PortalTooltip anchorRef={iconRef}>{infoDescription}</PortalTooltip>
      )}
    </>
  ) : null;
}

const ValueInfoIconLink = styled.a`
  position: relative;
`;

const ValueInfoIcon = styled.img`
  height: ${rem(16)};
  margin-left: ${rem(4)};
  filter: invert(1);
`;

export const TooltipText = styled.span`
  visibility: hidden;
  width: 160px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 6px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  bottom: 125%; /* show above the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: block;

  ${ValueInfoIconLink}:hover & {
    visibility: visible;
    opacity: 1;
  }

  ${({ theme }) => theme.mediab.m810`
      display: none;
  `};
`;
